import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  border: 1px solid #ccc;
  border-radius: 4px;

  ::placeholder {
    color: #1e3163;
  }
`;
